import { Box, ColorOptions, ModBox, Text } from '@jfs/ui-new'
import { FC } from 'react'
import { SvgImage } from '../../../../comps/SvgImage'
import { Colors, isOsMobile } from '../../../../util/util'

interface CheckBoxIconProps {
  header: string
  fontType: any
  size: number
  toggleAll: () => void
  color: any
}

const info = {
  Transaction: 'View and search transaction details',
  Settlement: 'User will be able to see settlement status & download report',
  Notification: 'User will receive SMS & Push notification for every transaction',
  'User Management': 'User will be able to Add/Delete any sub users but now owner',
  Refund: 'User will be able to view/process refund',
  'VIEW QR': 'User will be able to see QR code',
}
export const CheckBoxIcon: FC = ({ header, fontType, size, toggleAll, color, role, disabled }: any) => {
  return (
    <ModBox
      testID="checkbox-usr-mng"
      onPress={disabled ? () => console.log('No permissions') : toggleAll}
      disabled={disabled}
      underlayColor="TRANSPARENT"
      flexDirection={'row'}
      marginVertical={10}
      alignItems={'flex-start'}
      width={isOsMobile() ? '100%': '100vh'}
      flexWrap={'wrap'}>
      <Box width={25} opacity={disabled ? 0.5 : 1}>
        <SvgImage color={fontType === 'CheckboxOff' ? Colors.BLACK : color} imageName={fontType} />
      </Box>
      <Box width={'70%'} flexDirection={'row'}>
        <Text
          numberOfLines={5}
          letterSpacing={-0.06}
          fontSize={12}
          textAlign="justify"
          color={Colors.BLACK_14 as ColorOptions}
          fontFamily="JioType-Medium">
          {header}
        </Text>
      </Box>
    </ModBox>
  )
}
